import React from 'react'
import { Container, Row, Col, Button, Image } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import portadaLibro from '../../../../assets/img/libro/Libro_EM1.png'
import indicePdf from '../../../../assets/files/indice.pdf'
import './publications-book.css'

export default function PublicationsBook() {
  return (
    <section className='publications-book section__padding'>
      <Container>
        <h2 className='publications-section__title'>Libro</h2>
        <Row className='align-items-center g-4'>
          <Col md={6} className='publications-book__content'>
            <h3 className='publications-book__subtitle'>Educación Menstrual</h3>
            <p className='publications-book__description'>
              Un libro colectivo desde el sentipensar, la experiencia y la investigación científica, en clave feminista, interseccional e internacional.
            </p>
            <div className='publications-book__details'>
              <p>
                <span className='publications-book__highlight-red'>Educación Menstrual</span> es una obra colectiva pionera que articula
                <span className='publications-book__highlight-red'> pensamiento crítico, práctica educativa e investigación</span> para abordar la menstruación, el ciclo vital y los derechos menstruales.
              </p>
              <p>
                El libro reúne <span className='publications-book__highlight-red'>conocimientos, experiencias educativas y marcos teóricos</span> que reconocen la menstruación como un hecho
                <span className='publications-book__highlight-red'> biológico, social, histórico, político y cultural</span>, atravesado por diferentes formas de desigualdad e inequidad.
              </p>
              <p>
                Participan 14 autoras —investigadoras, educadoras, psicólogas, sociólogas y profesionales de otros ámbitos— que aportan
                <span className='publications-book__highlight-red'> conceptos, marcos de análisis y definiciones</span> para la educación en torno a la menarquia, la menstruación, el ciclo ovárico y menstrual, la fertilidad y el climaterio-menopausia.
              </p>
              <p>
                También desarrolla por primera vez una propuesta sistematizada sobre el rol, las funciones, los objetivos y los principios éticos de la educadora menstrual,
                ofreciendo <span className='publications-book__highlight-red'>criterios fundamentados para la práctica educativa</span> en contextos escolares, sociocomunitarios, laborales y otros ámbitos de intervención.
              </p>
              <p>
                Escrito en un <span className='publications-book__highlight-red'>lenguaje claro y accesible</span>, el libro busca acercar la educación menstrual tanto a personas interesadas en la temática como a
                <span className='publications-book__highlight-red'> profesionales de distintos ámbitos</span>, sin renunciar a la profundidad conceptual ni al rigor.
              </p>
              <p>
                La obra se completa con un <span className='publications-book__highlight-red'>glosario de educación menstrual con más de 120 definiciones, un manifiesto y una amplia bibliografía</span>, que reúne y conecta
                <span className='publications-book__highlight-red'> investigaciones, activismos y producciones teóricas</span> vinculadas a la cultura y la educación menstrual a nivel internacional.
              </p>
            </div>
            <div className='publications-book__actions'>
              <Button
                as='a'
                href='https://traficantes.net/libros/educaci%C3%B3n-menstrual'
                target='_blank'
                rel='noreferrer'
                className='publications-book__button publications-book__button--secondary'
              >
                Comprar libro
              </Button>
              <LinkContainer to='/libro'>
                <Button className='publications-book__button'>
                  Descubre todo sobre el libro
                </Button>
              </LinkContainer>
            </div>
          </Col>
          <Col md={6} className='publications-book__placeholder'>
            <div className='publications-book__cover'>
              <Image
                src={portadaLibro}
                alt='Portada del libro Educación Menstrual'
                className='publications-book__image publications-book__image--single'
              />
            </div>
            <a
              href={indicePdf}
              download
              className='publications-book__button publications-book__button--download'
            >
              Descargar índice
            </a>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
